import { SolutionCali } from "@assets/lottie";
import * as constants from "./constants";
import SolutionTemplate from "../../template";

export default function GlobalAssessment() {
    const props = {
        constants,
        animationData: SolutionCali,
    };
    return <SolutionTemplate {...props} />;
}
